// extracted by mini-css-extract-plugin
export var buttonSection = "footer-stylize-section-module--button-section--nz1yI";
export var emoji = "footer-stylize-section-module--emoji--RUA8y";
export var lastPhoto = "footer-stylize-section-module--last-photo--BobhF";
export var title = "footer-stylize-section-module--title--rJ9er";